import React from 'react';
import { FDBox, FDPaper } from '@facet-wealth/design';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import fr from 'facet-rest';
import { relationshipType } from 'facet-rest/src/consts/relationships';
import TabGroup from 'Components/ComponentLibrary/Molecules/TabGroup/TabGroup';
import { OutcomeInvestmentDetailsOverviewContainer } from './components/OutcomeInvestmentDetailsOverview/OutcomeInvestmentDetailsOverviewContainer';
import { OutcomeInvestmentDetailsAccountsContainer } from './components/OutcomeInvestmentDetailsAccounts/OutcomeInvestmentDetailsAccountsContainer';

const OutcomeInvestmentDetailsSection = () => {
  const { resource } = useMetaLayoutContext();
  const tabLinks = resource.relationships().list().filter(link => link.meta('type') === relationshipType.tabLink);
  if (tabLinks.length === 0) {
    return null;
  }

  const LAYOUTS = {
    [fr.relationships.outcomeAccountsAggregatedBreakdown.name]: <OutcomeInvestmentDetailsOverviewContainer relationship={resource.relationship(fr.relationships.outcomeAccountsAggregatedBreakdown.name)} />,
    [fr.relationships.outcomeAccountsBreakdown.name]: <OutcomeInvestmentDetailsAccountsContainer relationship={resource.relationship(fr.relationships.outcomeAccountsBreakdown.name)} />,
  };

  return (
    <FDPaper appearance={'flat'} width={'100%'}>
      <FDBox paddingX={2}>
        <TabGroup resource={resource} layouts={LAYOUTS} />
      </FDBox>
    </FDPaper>
  );
};

export { OutcomeInvestmentDetailsSection };
